import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

const ApplicationModal = ({ isOpen, onClose, onSubmit, matchTitle, questions, isSubmitting }) => {
  const [message, setMessage] = useState('');
  const [answers, setAnswers] = useState(questions?.map(q => ({ question: q, answer: '' })) || []);

  if (!isOpen) return null;

  const handleAnswerChange = (index, value) => {
    const newAnswers = [...answers];
    newAnswers[index].answer = value;
    setAnswers(newAnswers);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(message, answers);
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-900 border-l-4 border-red-500 rounded-sm w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]">
        <div className="p-6 border-b border-gray-800 flex justify-between items-center shrink-0">
          <div>
            <h2 className="text-xl font-bold text-white">Apply to Join</h2>
            <p className="text-sm text-gray-400 mt-1">{matchTitle}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition">
            <FiX size={24} />
          </button>
        </div>

        <div className="p-6 overflow-y-auto">
          <form id="application-form" onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">
                Message to Organizer (Optional)
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Hi, I'd love to join this match..."
                rows="3"
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 text-white rounded focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500/30 transition text-sm resize-none"
              />
            </div>

            {questions && questions.length > 0 && (
              <div className="space-y-4">
                <p className="text-xs font-bold text-red-500 uppercase tracking-widest border-b border-gray-800 pb-2">
                  Organizer Questions
                </p>
                {questions.map((q, idx) => (
                  <div key={idx}>
                    <label className="block text-sm text-gray-300 mb-2 font-medium">
                      {q} *
                    </label>
                    <input
                      type="text"
                      required
                      value={answers[idx]?.answer || ''}
                      onChange={(e) => handleAnswerChange(idx, e.target.value)}
                      placeholder="Your answer"
                      className="w-full px-4 py-2 bg-gray-800 border border-gray-700 text-white rounded focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500/30 transition text-sm"
                    />
                  </div>
                ))}
              </div>
            )}
          </form>
        </div>

        <div className="p-6 border-t border-gray-800 flex justify-end gap-3 shrink-0 bg-gray-900">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-300 hover:text-white font-semibold transition"
          >
            Cancel
          </button>
          <button
            type="submit"
            form="application-form"
            disabled={isSubmitting}
            className="bg-red-500 hover:bg-red-600 disabled:opacity-50 text-white px-6 py-2 rounded font-bold transition"
          >
            {isSubmitting ? 'Submitting...' : 'Submit Application'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationModal;
